<div class="homeComponent">
  <div class="homeEvents">
    <h1 class="ms-4 me-2 mt-4 mb-4">Today's Events & Hearings</h1>
    <app-today-events></app-today-events>
  </div>
  <div class="homeStateHouse">
    <div class="homeWelcomeMessage">
      <div class="homeWelcomeTop row mt-5">The Massachusetts</div>
      <div class="homeWelcomeBottom row">State</div>
      <div class="homeWelcomeBottom row">House</div>
    </div>
    <div class="homeLinkRow row justify-content-center">
      <div class="homeRouteButton col-3 btn btn-default me-3" routerLink="/directory" routerLinkActive="active">
        <span><fa-icon [icon]="faUsers"></fa-icon></span>
        <div class="homeButtonText">
          Room Directory
        </div>
      </div>
      <div class="homeRouteButton col-3 btn btn-default mx-3 grid-" routerLink="/events-and-hearings" routerLinkActive="active">
          <span><fa-icon [icon]="faCalendarAlt"></fa-icon></span>
          <div class="homeButtonText">
              Events &amp; Hearings
          </div>
      </div>
        <div class="homeRouteButton col-3 btn btn-default ms-3" routerLink="/about" routerLinkActive="active">
          <span><fa-icon [icon]="faInfoCircle"></fa-icon></span>
          <div class="homeButtonText">
            About the State House
          </div>
        </div>
    </div>
  </div>
</div>

